import type { Service } from "../types/Service";

// Icon components
const UiUxIcon: React.FC = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
    ></path>
  </svg>
);

const BrandingIcon: React.FC = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
    ></path>
  </svg>
);

const WebDesignIcon: React.FC = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    ></path>
  </svg>
);

const MobileDesignIcon: React.FC = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <rect
      x="5"
      y="2"
      width="14"
      height="20"
      rx="2"
      ry="2"
      strokeWidth="2"
    ></rect>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 18h.01"
    ></path>
  </svg>
);

export const services: Service[] = [
  {
    id: 1,
    title: "Event & Invitation Design",
    desc: "Elegant visual concepts for events, celebrations, and special occasions — from printed invitations to digital announcements that capture the right mood and story.",
    icon: UiUxIcon,
  },
  {
    id: 2,
    title: "Brand & Visual Identity",
    desc: "Strategic and aesthetic branding that reflects your values, personality, and audience — from logos to complete visual systems.",
    icon: BrandingIcon,
  },
  {
    id: 3,
    title: "Graphic & Communication Design",
    desc: "Designs that blend creativity with clarity — transforming messages into visuals that connect and inspire across print and digital media.",
    icon: WebDesignIcon,
  },
  {
    id: 4,
    title: "Motion & Presentation Design",
    desc: "Engaging animated visuals and presentation materials that elevate your storytelling and enhance audience experience.",
    icon: MobileDesignIcon,
  },
];
